import './bootstrap';
import '../css/app.css';

import { createApp } from 'vue'; // Import Vue 3's createApp function
import OrganizePdf from './Components/OrganizePdf.vue';
import MergePdf from './Components/MergePdf.vue';
import PdfToWord from './Components/PdfToWord.vue';
import SplitPdf from './Components/SplitPdf.vue';

const app = createApp({
    components: {
        OrganizePdf,
        MergePdf,
        PdfToWord,
        SplitPdf
    },

});
app.mount('#app');


